'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright 2015 Oursky Ltd.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @private
 */
var Cache = function () {
  function Cache(prefix, store) {
    (0, _classCallCheck3.default)(this, Cache);

    this._maxRetryCount = 1;
    this.prefix = prefix;
    this.map = {};
    this.store = store;
  }

  (0, _createClass3.default)(Cache, [{
    key: '_applyNamespaceOnKey',
    value: function _applyNamespaceOnKey(key) {
      return this.prefix + ':' + key;
    }
  }, {
    key: 'set',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(key, value) {
        var namespacedKey, stringifiedValue;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                namespacedKey = this._applyNamespaceOnKey(key);

                this.map[namespacedKey] = value;
                stringifiedValue = JSON.stringify(value);
                return _context.abrupt('return', this._setWithRetry(namespacedKey, stringifiedValue));

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function set(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return set;
    }()
  }, {
    key: '_setWithRetry',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(namespacedKey, stringifiedValue) {
        var attempt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.store.setPurgeableItem(namespacedKey, stringifiedValue);

              case 3:
                _context2.next = 10;
                break;

              case 5:
                _context2.prev = 5;
                _context2.t0 = _context2['catch'](0);

                if (!(attempt >= this._maxRetryCount)) {
                  _context2.next = 9;
                  break;
                }

                throw _context2.t0;

              case 9:
                return _context2.abrupt('return', this._setWithRetry(namespacedKey, stringifiedValue, attempt + 1));

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 5]]);
      }));

      function _setWithRetry(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return _setWithRetry;
    }()
  }, {
    key: 'get',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(key) {
        var namespacedKey, jsonStr, cachedJSON;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                namespacedKey = this._applyNamespaceOnKey(key);

                if (!this.map[namespacedKey]) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return', this.map[namespacedKey]);

              case 3:
                _context3.next = 5;
                return this.store.getItem(namespacedKey);

              case 5:
                jsonStr = _context3.sent;

                if (!jsonStr) {
                  _context3.next = 9;
                  break;
                }

                cachedJSON = JSON.parse(jsonStr);
                return _context3.abrupt('return', cachedJSON);

              case 9:
                throw Error('key ' + key + ' not found in store');

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get(_x6) {
        return _ref3.apply(this, arguments);
      }

      return get;
    }()
  }]);
  return Cache;
}();

exports.default = Cache;
module.exports = exports['default'];